import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResolveJurisdictionMutationVariables = Types.Exact<{
  input: Types.ResolveJurisdictionInput;
}>;


export type ResolveJurisdictionMutation = { __typename?: 'mutation_root', resolve_jurisdiction?: { __typename?: 'ResolveJurisdictionOutput', success: boolean, resolved: boolean, domain?: string | null, work_kind?: string | null, jurisdiction_id?: any | null, jurisdiction_name?: string | null, match_method?: string | null, confidence?: string | null, needs_confirmation?: boolean | null, distance_to_boundary_meters?: number | null, latitude?: number | null, longitude?: number | null, geocode_location_type?: string | null, message?: string | null, error?: string | null, alternatives?: Array<{ __typename?: 'ResolveJurisdictionCandidate', jurisdiction_id?: any | null, jurisdiction_name?: string | null, reason?: string | null }> | null, context?: Array<{ __typename?: 'ResolveJurisdictionArea', type_code?: string | null, type_name?: string | null, name?: string | null, jurisdiction_id?: any | null, authority_source?: string | null, published_authority_name?: string | null }> | null } | null };


export const ResolveJurisdictionDocument = gql`
    mutation resolveJurisdiction($input: ResolveJurisdictionInput!) {
  resolve_jurisdiction(input: $input) {
    success
    resolved
    domain
    work_kind
    jurisdiction_id
    jurisdiction_name
    match_method
    confidence
    needs_confirmation
    distance_to_boundary_meters
    latitude
    longitude
    geocode_location_type
    alternatives {
      jurisdiction_id
      jurisdiction_name
      reason
    }
    context {
      type_code
      type_name
      name
      jurisdiction_id
      authority_source
      published_authority_name
    }
    message
    error
  }
}
    `;
export type ResolveJurisdictionMutationFn = Apollo.MutationFunction<ResolveJurisdictionMutation, ResolveJurisdictionMutationVariables>;

/**
 * __useResolveJurisdictionMutation__
 *
 * To run a mutation, you first call `useResolveJurisdictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveJurisdictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveJurisdictionMutation, { data, loading, error }] = useResolveJurisdictionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveJurisdictionMutation(baseOptions?: Apollo.MutationHookOptions<ResolveJurisdictionMutation, ResolveJurisdictionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveJurisdictionMutation, ResolveJurisdictionMutationVariables>(ResolveJurisdictionDocument, options);
      }
export type ResolveJurisdictionMutationHookResult = ReturnType<typeof useResolveJurisdictionMutation>;
export type ResolveJurisdictionMutationResult = Apollo.MutationResult<ResolveJurisdictionMutation>;
export type ResolveJurisdictionMutationOptions = Apollo.BaseMutationOptions<ResolveJurisdictionMutation, ResolveJurisdictionMutationVariables>;